import React, { useEffect, useState } from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import Icon from "../Icon/Icon";
import classNames from "classnames";
import Styles from "./Tooltip.module.scss";
import "./Border.css";
import "react-tooltip/dist/react-tooltip.css";

interface Props {
  id: string;
  tooltip: string | React.ReactElement;
  variant?: "dark" | "light" | "success" | "warning" | "error" | "info";
  className?: string;
  iconSize?: string;
}

const Tooltip = ({ id, tooltip, variant = "light", className, iconSize = "18px" }: Props) => {
  const [width, setWidth] = useState("100%");

  const calcWidth = () => {
    const width = window.innerWidth;
    width < 500 && setWidth(`${width}px`);
  };

  useEffect(() => {
    calcWidth();
    window.addEventListener("resize", calcWidth);
    return () => window.removeEventListener("resize", calcWidth);
  }, []);

  const anchor = `${id}_tooltip`;
  return (
    <>
      <span
        id={anchor}
        tabIndex={0}
        role="button"
        aria-label={`More information: ${typeof tooltip === "string" ? tooltip : ""}`}
        onKeyDown={(e: React.KeyboardEvent) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            const tooltipElement = document.querySelector(`#${anchor}`);
            if (tooltipElement) {
              tooltipElement.dispatchEvent(new MouseEvent("mouseenter"));
            }
          }
        }}
      >
        <Icon name="infoIconPlain" size={iconSize} className={classNames(Styles.icon, className)} />
      </span>
      <ReactTooltip
        anchorSelect={`#${anchor}`}
        variant={variant}
        className={Styles.tooltip}
        style={{ width }}
        events={["hover"]}
      >
        {tooltip}
      </ReactTooltip>
    </>
  );
};

export default Tooltip;
